import { QueryConfig } from "store/utils/query-config";

export const chatBotInstancesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"]
  }
};
